import { render, staticRenderFns } from "./SmallSearchBox.vue?vue&type=template&id=32e15b2f&scoped=true"
import script from "./SmallSearchBox.vue?vue&type=script&lang=js"
export * from "./SmallSearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e15b2f",
  null
  
)

export default component.exports